import React, { useEffect, useState, useRef } from "react";
import "./AutoScrollCard.css";

const AutoSlideCards = ({ items, interval = 4000 }) => {
  const [index, setIndex] = useState(0);
  const timerRef = useRef(null);

  const startAutoSlide = () => {
    stopAutoSlide();
    timerRef.current = setInterval(() => {
      setIndex((prev) => (prev + 1) % items.length);
    }, interval);
  };

  const stopAutoSlide = () => {
    if (timerRef.current) clearInterval(timerRef.current);
  };

  useEffect(() => {
    if (items.length) startAutoSlide();
    return () => stopAutoSlide();
    // eslint-disable-next-line
  }, [items, interval]);

  const prevSlide = () => {
    setIndex((prev) => (prev - 1 + items.length) % items.length);
  };

  const nextSlide = () => {
    setIndex((prev) => (prev + 1) % items.length);
  };

  return (
    <div
      className="slider-container"
      onMouseEnter={stopAutoSlide}
      onMouseLeave={startAutoSlide}
    >
      {/* LEFT ARROW */}
      <button className="nav-arrow left" onClick={prevSlide}>
        &#10094;
      </button>

      {/* SLIDER */}
      <div
        className="slider-track"
        style={{ transform: `translateX(-${index * 100}%)` }}
      >
        {items.map((item, i) => (
          <div className="slider-card" key={i}>
            {/* LEFT IMAGE */}
            <div className="slider-image">
              <img src={item.image} alt={item.title} />
            </div>

            {/* RIGHT CONTENT */}
            <div className="slider-text">
              <h3 className="slider-title">{item.title}</h3>
              <p className="slider-description">{item.text}</p>
            </div>
          </div>
        ))}
      </div>

      {/* RIGHT ARROW */}
      <button className="nav-arrow right" onClick={nextSlide}>
        &#10095;
      </button>
    </div>
  );
};

export default AutoSlideCards;
